/**
 * FEAT-2026-0006: Triaxial photo workflow.
 *
 * Rock Direct Shear uses fixed (stage, position) slots — see `photo.ts`.
 * Triaxial replaces that with three free-form categories plus a user-chosen
 * count per category. We reuse the existing Photo.Stage and Photo.Position
 * columns: Stage holds the category id, Position holds a 1-based numeric
 * index ("1", "2", ...) so multiple photos can live in the same category.
 */

export type TriaxialPhotoCategoryId = 'before' | 'after' | 'closeup';

export interface TriaxialPhotoCategory {
  id: TriaxialPhotoCategoryId;
  label: string;
  description: string;
}

export const TRIAXIAL_PHOTO_CATEGORIES: TriaxialPhotoCategory[] = [
  { id: 'before',  label: 'Sample Before Testing',    description: 'Photos of the specimen prior to setup.' },
  { id: 'after',   label: 'Sample After Testing',     description: 'Photos of the specimen after testing.' },
  { id: 'closeup', label: 'Close-up Photo of Sample', description: 'Detail shots highlighting features.' },
];
